import React, { useContext } from 'react';
import ModalItem from '../../common/ModalItem/ModalItem';
import { Container, Hidden, TextField } from '@material-ui/core';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import './admin-payment.scss';
import { changeErrorPopupState } from '../../../store/uiSlice';
import { postPaymentRequest } from '../../../store/paymentSlice';
import { connect } from 'react-redux';
import YellowButton from '../../common/YellowButton';
import { completedRoutes } from '../../../common/constants';
import { Route, Switch, useHistory, useLocation } from 'react-router';
import CustomBackdrop from '../../common/CustomBackdrop';
import IsMobileContext from '../../../common/IsMobileContext';
import Code from './AdminPaymentCode';
import ScoreToRubblesInfo from '../../common/ScroreToRubbleInfo';
import { withStyles } from '@material-ui/styles';
import { get } from 'lodash';

const ContentSwitch = (props) => {
  const { desktopOption, content, placeId } = props;

  return (
    <Switch>
      <Route path={completedRoutes.adminPaymentCode(placeId)}>
        <Code />
      </Route>
      {desktopOption &&
      <Route>
        {content}
      </Route>
      }
    </Switch>
  );
};

const CssTextField = withStyles({
  root: {
    '& label.Mui-focused': {
      color: 'black',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#FEEB17',
      },
      '&:hover fieldset': {
        borderColor: '#FEEB17',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#FEEB17',
      },
    },
  },
})(TextField);

function AdminPayment(props) {
  const { t } = useTranslation();
  const history = useHistory();
  const isMobileDesign = useContext(IsMobileContext);
  const location = useLocation();
  const placeId = get(location, 'state.placeId', null);

  const { postPaymentRequest, changeErrorPopupState, fetchingState } = props;

  const formik = useFormik({
    initialValues: {
      amount: '',
    },
    validate: (values) => {
      const errors = {};
      if (+values.amount < 10) {
        errors.amount = t('adminPayment.input');
      }
      return errors;
    },
    onSubmit: (values) => {
      const { amount } = values;
      postPaymentRequest(placeId, amount)
        .then(() => {
          history.push(completedRoutes.adminPaymentCode(placeId), { placeId });
        })
        .catch((error) => {
          if (error.status === 401) {
            history.replace(completedRoutes.signUp, { currentUrl: completedRoutes.adminPayment(placeId), placeId });
          } else {
            console.error(error);
            changeErrorPopupState({ error, type: 'default', isOpen: true });
          }
        });
    },
  });

  if (placeId === null) return null;
  const isLoading = fetchingState === 'requesting';

  const content = (
    <Container className="get-payment-cnt">
      <h2>{t('adminPayment.title')}</h2>
      <form onSubmit={formik.handleSubmit}>
        <CssTextField
          className="text-input"
          variant="outlined"
          label={t('adminPayment.inputLabel')}
          name="amount"
          type="number"
          value={formik.values.amount}
          onChange={formik.handleChange}
          error={!!formik.errors.amount}
        />
        <div><ScoreToRubblesInfo /></div>
        <p className="p1">
          {t('adminPayment.p1')}
        </p>
        <YellowButton title={t('common.next')}
                      type="submit"
                      hidden={false}
                      disabled={formik.errors.amount || formik.values.amount === ''}
        />
      </form>
    </Container>
  );

  return (
    <ModalItem withBackButton={false}>
      <>
        <Hidden mdUp>
          {content}
        </Hidden>
        <ContentSwitch desktopOption={!isMobileDesign} content={content} placeId={placeId} />
        <CustomBackdrop open={isLoading} />
      </>
    </ModalItem>
  );
}

const mapStateToProps = state => ({
  fetchingState: state.payments.fetchingState,
});

const actionCreators = {
  postPaymentRequest: postPaymentRequest,
  changeErrorPopupState: changeErrorPopupState,
};

export default connect(mapStateToProps, actionCreators)(AdminPayment);
